import { buttonVariants } from "@/app/common/components/Button";
import { SuccessCircleIcon } from "@/app/common/icons/general";
import { AppRoutePaths } from "@/routing/route_paths";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FamilyWizardLayout from "../../FamilyWizardLayout";

export function VerificationOutcome() {
    const {t} = useTranslation()

    return (
        <FamilyWizardLayout>
            <FamilyWizardLayout.Header>
                <h1 className="text-3xl font-medium text-gray-800">
                    {t('complete')}
                </h1>
            </FamilyWizardLayout.Header>
            <SuccessCircleIcon />
            <FamilyWizardLayout.Content className="text-center">
                <h2 className="text-lg text-gray-800 font-medium mb-2 mt-4">

                    {t('income_details_successfully_submitted_title')}
                </h2>
                <p className="text-gray-700">
                    {t("income_details_successfully_submitted_desc")}
                </p>
            </FamilyWizardLayout.Content>
            <FamilyWizardLayout.ActionBar>
                <Link className={buttonVariants({
                    variant: "primary",
                    className: "w-full"
                })} to={AppRoutePaths.family_application.review_application}>
                    {t("continue")}
                </Link>
            </FamilyWizardLayout.ActionBar>
        </FamilyWizardLayout>
    )


}